<div
  class="checkout-linked-account-container"
  [ngSwitch]="componentRenderState()"
  [class.linked-account-top]="shouldRenderLinkedAccountOnTop">
  <div
    class="linked-account-loading button-height rounded-md"
    *ngSwitchCase="'loading'"></div>

  <div *ngSwitchCase="'linked'" class="linked-account-container">
    <div class="linked-account-label">
      {{
        'transfer_v2.checkout.linked_account'
          | translate
            : {
                loyaltyProgramShortName: loyaltyProgram.shortName
              }
      }}
    </div>
    <div class="linked-account-information">
      <span class="linked-account-number">{{ linkedAccount.number }}</span>
      <button
        class="change-linked-account-button focus-link"
        (click)="openLinkAccountDialog()"
        type="button">
        <span class="change-linked-account-text">
          {{ 'transfer_v2.checkout.edit' | translate }}
        </span>
      </button>
    </div>
  </div>

  <div *ngSwitchCase="'unlinked'" class="link-your-account">
    <rd-shared-button
      class="link-your-account-button"
      [buttonClass]="'link-your-account-button'"
      [buttonContent]="buttonContent"
      [buttonTheme]="'primary'"
      (clickFn)="openLinkAccountDialog()">
      <ng-template #buttonContent>
        <span
          class="link-your-account-text"
          [class.has-icon]="shouldRenderLinkAccountButtonIcon">
          {{ 'transfer_v2.checkout.link_your_account' | translate }}
          <rd-shared-icon
            *ngIf="shouldRenderLinkAccountButtonIcon"
            class="arrow-icon"
            [iconSymbol]="'icon-arrow-right'"
            [iconTheme]="'white'"></rd-shared-icon>
        </span>
      </ng-template>
    </rd-shared-button>
  </div>
</div>
